import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom"; // Import BrowserRouter, Routes, and Route
import './index.scss'

import { AuthProvider } from "./Contexts/AuthContext";
import App from "./App";
import Home from "./Pages/Home";
import Error from "./Pages/Error404";
import About from "./Pages/About";
import Innovation from "./Pages/Innovation/Index";
import Consultancy from "./Pages/Consultancy/Index";
import Support from "./Pages/Support/Index";
import Blog from "./Pages/Blog/index";
import Products from "./Pages/Products";
import EasyMovePage from "./Pages/Products/Produtos/EasyMove";
import EasyMove from "./Pages/Admin/EasyMove"; 
import Admin from "./Pages/Admin";
import AdminHome from "./Pages/Admin/Home";
import LoginPage from "./Pages/Admin/Login"; 

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<App />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/innovation" element={<Innovation />} />
            <Route path="/consultancy" element={<Consultancy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/EasyMove" element={<EasyMovePage />} />
            <Route path="*" element={<Error />} />
          </Route>

          {/* Rotas do Admin - Login não protegido */}
          <Route path="/admin/login" element={<LoginPage />} />
          
          {/* Rotas do Admin - Todas protegidas com layout compartilhado */}
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/home" element={<AdminHome />} />
          <Route path="/admin/easymove" element={<EasyMove />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);